/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import type { MutationsObject } from '@kp/js-model';
import { LookupCollection } from './BaseCollection';

export class Land extends BaseModel {
    id: number | null = null;
    name: string | null = null;
    laendercode: string | null = null;

    public mutations(): MutationsObject {
        return {
            id: (id: number) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    getClassName(): string {
        return 'land';
    }
};

export class LandCollection extends LookupCollection<Land> {
    protected modelCls = Land;
    getModelClassName(): string {
        return 'land'
    }
}
